import { ACTIONS, GAME_ID } from '../dataManagement/Constants';

const initialState = {
  showBowlOf: 0,
  showAnimationOf: 0,
};

const progressViewData = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case ACTIONS.INIT_SHADES_SESSION:
      return initialState;

    case ACTIONS.SHOW_ANIMATION_OF:
      return {
        ...state,
        showAnimationOf: action.payload,
      };

    case ACTIONS.SHOW_BOWL_OF:
      return {
        ...state,
        showBowlOf: action.payload,
      };

    default:
      return state;
  }
};

export default progressViewData;
